/**
 * BscScan link helper only — no RPC calls from the browser.
 * All chain reads (status, deposits, balances) go through the backend
 * (/api/wallet/chain/status, /api/wallet/deposit-address, etc.) so the
 * QuickNode/RPC endpoint is never exposed to the client bundle.
 */
export function getBscScanUrl(txHash) {
  if (!txHash) return '';
  // Since we are strictly using Testnet as per plan
  return `https://testnet.bscscan.com/tx/${txHash}`;
}
